import React, { useState, useEffect } from 'react';
import { useVideoService } from '../../contexts/VideoServiceContext';
import './FloatingVideo.css';

const FloatingVideo = () => {
  const [visible, setVisible] = useState(true);
  const [hasStream, setHasStream] = useState(false);
  const videoService = useVideoService();
  const { VideoComponent } = videoService || {};

  useEffect(() => {
    if (!videoService) return;

    const handleStreamChange = (stream) => {
      setHasStream(!!stream);
      if (stream) setVisible(true);
    };

    // Initial check
    setHasStream(videoService.isCameraOn());

    const unsubscribe = videoService.onStreamChange(handleStreamChange);
    return () => {
      unsubscribe();
    };
  }, [videoService]);

  if (!VideoComponent || !hasStream) return null;

  return (
    <>
      {visible && (
        <div className="floating-video-container centered-bottom">
          <button className="floating-video-toggle" onClick={() => setVisible(false)} style={{ zIndex: 2, position: 'relative' }}>Hide</button>
          <div style={{ zIndex: 2, position: 'relative', width: '100%' }}>
            <VideoComponent />
          </div>
        </div>
      )}
      {!visible && (
        <button
          className="floating-video-show-btn centered-bottom"
          onClick={() => setVisible(true)}
        >
          Show Video
        </button>
      )}
    </>
  );
};

export default FloatingVideo;